module.exports = __webpack_public_path__ + "media/customizations/wilderranch/back-83d890065df7962a6a02fcaf5f5c02bc.jpg";